import { render, staticRenderFns } from "./SkillsForm.vue?vue&type=template&id=0007e780&scoped=true&"
import script from "./SkillsForm.vue?vue&type=script&lang=ts&"
export * from "./SkillsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SkillsForm.vue?vue&type=style&index=0&id=0007e780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007e780",
  null
  
)

export default component.exports